export const styles = {
	topbar:
		'sticky top-0 z-10 flex items-center justify-between gap-md border-b border-subtle bg-white/95 px-xl py-sm backdrop-blur',
	content: 'flex flex-col gap-lg px-xl py-lg',
	pageEyebrow: 'mb-2xs text-[11px] font-medium uppercase tracking-wider text-purple-700',
	pageH1: 'text-[26px] font-semibold leading-tight tracking-tight text-default',
	pageSub: 'mt-3xs text-[13px] text-subtle',
	filterRow: 'flex flex-wrap items-center gap-3xs border-y border-subtle py-sm',
	filterInput:
		'w-full rounded-md border border-subtle bg-white px-xs py-2xs pl-xl text-[13px] text-default placeholder:text-subtle focus:border-action-primary focus:outline-none focus:ring-2 focus:ring-action-primary/15',
	select:
		'rounded-md border border-subtle bg-white px-xs py-2xs pr-lg text-[13px] text-default appearance-none bg-no-repeat focus:border-action-primary focus:outline-none focus:ring-2 focus:ring-action-primary/15',
	companyId: 'mt-3xs block font-mono text-[11px] leading-none text-subtle',
	tableHeader: 'text-[10px] font-medium uppercase tracking-wider text-subtle',
	tableCell: 'text-[13px] text-default',
	tableCellMuted: 'text-[13px] text-subtle',
	userAvatar:
		'inline-flex h-xl w-xl shrink-0 items-center justify-center rounded-full border border-subtle bg-grey-25 text-[10px] font-semibold leading-none text-default',
	statusActive: 'inline-flex items-center gap-3xs text-[12px] text-default',
	statusClosed: 'inline-flex items-center text-[12px] text-subtle',
	statusHandoff:
		'inline-flex items-center gap-3xs rounded-md bg-surface-warning px-2xs py-3xs text-[11px] font-medium leading-none text-warning',
	statusError:
		'inline-flex items-center gap-3xs rounded-md bg-surface-error px-2xs py-3xs text-[11px] font-medium leading-none text-error',
	areaChip:
		'inline-flex items-center rounded-md bg-grey-25 px-2xs py-3xs font-mono text-[10px] leading-none text-subtle transition-colors hover:bg-grey-50 hover:text-default',
	// Severity is encoded in colour as well as in the label so a row that needs
	// attention reads at a glance, without the operator parsing every chip.
	alertChip: {
		high: 'inline-flex items-center rounded-md bg-surface-error px-2xs py-3xs text-[10px] font-medium leading-none text-error transition-opacity hover:opacity-80',
		mid: 'inline-flex items-center rounded-md bg-surface-warning px-2xs py-3xs text-[10px] font-medium leading-none text-warning transition-opacity hover:opacity-80',
		low: 'inline-flex items-center rounded-md bg-grey-50 px-2xs py-3xs text-[10px] font-medium leading-none text-subtle transition-colors hover:text-default',
	},
	// `action-primary` is the *button* token: `text-action-primary` resolves to
	// white (foreground on a primary fill) and there is no `bg-action-primary`
	// utility, so the pill rendered white-on-transparent — present in the DOM
	// and invisible on screen. These two are the theme's purple pair, the same
	// one the sidebar's active item and the page eyebrow use.
	activeFacet:
		'inline-flex items-center gap-3xs rounded-full bg-purple-50 px-xs py-3xs text-[11px] font-medium leading-none text-purple-700 transition-colors hover:bg-purple-50/70',
	dotSuccess: 'inline-block h-2xs w-2xs rounded-full bg-green-500',
	pageBtn:
		'inline-flex h-[28px] w-[28px] items-center justify-center rounded-md text-[12px] font-medium leading-none tabular-nums text-subtle transition-colors hover:bg-grey-25 hover:text-default disabled:pointer-events-none disabled:opacity-40',
	pageBtnActive:
		'inline-flex h-[28px] w-[28px] items-center justify-center rounded-md text-[12px] font-semibold leading-none tabular-nums bg-grey-50 text-default',
};
